import { useCallback } from 'react';
import { prop } from 'ramda';

import { useUserSelector } from '@core/js/store/hooks';

export const useComposePlayerTagsForThunderbyteUrl = () => {
    const allPlayerTags = useUserSelector(prop('allPlayerTags'));

    return useCallback((launchUrlStr = '') => {
        const replacer: string | undefined = launchUrlStr.match(/\[playertags:\S*\]/)?.[0];

        if (!replacer) {
            return '';
        }

        const tags = replacer
            .substring(12, replacer.length - 1)
            .split(',');

        return Object.keys(allPlayerTags || {})
            .reduce((acc: string[], tagName: string) => {
                if (tags.find(tag => tag.includes(tagName.substring(0, tagName.indexOf('/'))))) {
                    if (allPlayerTags?.[tagName]?.value) {
                        acc.push(allPlayerTags[tagName].value as string);
                    } else {
                        acc.push(tagName.substring(tagName.indexOf('/') + 1));
                    }
                }

                return acc;
            }, [])
            .join(',');
    }, [allPlayerTags]);
};
